"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleStringContainer_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SimpleStringContainer_Factory = /** @class */ (function () {
    function SimpleStringContainer_Factory() {
    }
    SimpleStringContainer_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Value: model.Value,
        };
        return result;
    };
    SimpleStringContainer_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Value: model.Value,
        };
        return result;
    };
    return SimpleStringContainer_Factory;
}());
exports.SimpleStringContainer_Factory = SimpleStringContainer_Factory;
